import { Button, CircularProgress, Icon, Typography } from "@mui/material";

export type ButtonProps = {
  text?: string;
  disabled?: boolean;
  submit?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  startIcon?: string | JSX.Element;
  endIcon?: string | JSX.Element;
  color?: string;
  bgcolor?: string;
  height?: string;
  variant?: "text" | "contained" | "outlined";
  width?: string;
  fontSize?: string;
  fontWeight?: string;
  fontFamily?: string;
  border?: string;
  borderRadius?: string;
  minWidth?: string;
  justifyContent?: string;
  id?: string;
  dataTestId?: string;
  pointerEvents?: string;
  type?: "submit" | "button" | "reset" | undefined;
};

export const CustomButton = ({
  text = "",
  id = "",
  disabled = false,
  submit = () => {},
  startIcon = undefined,
  endIcon = undefined,
  color = undefined,
  bgcolor = undefined,
  height = undefined,
  variant = "contained",
  width = "auto",
  fontSize = "15px",
  fontWeight = "500",
  fontFamily = "Poppins",
  border = "none",
  borderRadius = "9px",
  minWidth = "auto",
  justifyContent = "center",
  dataTestId = "",
  pointerEvents = "all",
  type = "submit",
}: ButtonProps) => {
  const styles = {
    backgroundColor: bgcolor || "#34B47480 !important",
    color: disabled ? "#2A945F" : color || "inherit",
    textTransform: "initial",
    fontWeight,
    fontFamily,
    fontSize,
    height: height || "auto",
    borderRadius,
    boxShadow: "none",
    width,
    border,
    minWidth,
    display: "flex",
    justifyContent,
    textAlign: "center !important",
    pointerEvents,
  };

  return startIcon ? (
    <Button
      id={id}
      variant={variant}
      fullWidth
      // color={color}
      sx={styles}
      onClick={submit}
      disabled={disabled}
      type={type}
      startIcon={startIcon}
      data-testid={dataTestId}
    >
      {text ? text : <CircularProgress size={25} />}
    </Button>
  ) : endIcon ? (
    <Button
      id={id}
      variant={variant}
      fullWidth
      // color={color}
      sx={styles}
      onClick={submit}
      disabled={disabled}
      type={type}
      endIcon={endIcon}
      data-testid={dataTestId}
    >
      {text ? text : <CircularProgress size={25} />}
    </Button>
  ) : (
    <Button
      id={id}
      variant={variant}
      fullWidth
      // color={color}
      sx={styles}
      onClick={submit}
      disabled={disabled}
      type={type}
      data-testid={dataTestId}
    >
      {text ? text : <CircularProgress size={25} />}
    </Button>
  );
};
